












import Vue from 'vue'
import Component from 'vue-class-component'

import SettingsHelperComponents4PersonalInformationResourceItem from './settings-helper-components-4-personal-information-resource-item.vue'
import SettingsHelperComponents5NetworkResourceItem from './settings-helper-components-5-network-resource-item.vue'
// import SettingsHelperComponents6ApplicationResourceItem from './settings-helper-components-6-application-resource-item.vue'
// import SettingsHelperComponents7DeveloperTeamResourceItem from './settings-helper-components-7-developer-team-resource-item.vue'

@Component({
  components: {
    SettingsHelperComponents4PersonalInformationResourceItem,
    SettingsHelperComponents5NetworkResourceItem // ,
    // SettingsHelperComponents6ApplicationResourceItem // ,
    // SettingsHelperComponents7DeveloperTeamResourceItem
  }
})
class SettingsHelperComponents3ResourceList extends Vue {

}

export default SettingsHelperComponents3ResourceList

